import { useState, useCallback } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card'
import { 
  Package, Truck, FileText, Calculator, Globe, Shield,
  CheckCircle
} from 'lucide-react'

const Services = () => {
  const services = [
    { icon: Package,   title: "Antrepo İşlemleri",  description: "Gümrük antrepo işlemlerinizi profesyonel şekilde yönetiyoruz.", features: ["Depolama hizmetleri","Stok yönetimi","Güvenli saklama"], color: "blue" },
    { icon: Truck,     title: "İthalat & İhracat",  description: "İthalat ve ihracat işlemlerinizde tam destek sağlıyoruz.",     features: ["Gümrük beyannameleri","Belge hazırlama","Takip sistemi"], color: "green" },
    { icon: FileText,  title: "Belge Yönetimi",     description: "Tüm gümrük belgelerinizi eksiksiz hazırlıyoruz.",            features: ["Fatura düzenleme","Sertifika işlemleri","Dijital arşiv"], color: "purple" },
    { icon: Calculator,title: "Vergi Hesaplama",    description: "Gümrük vergi ve harçlarınızı doğru hesaplıyoruz.",           features: ["Vergi optimizasyonu","Harç hesaplama","Mali danışmanlık"], color: "orange" },
    { icon: Globe,     title: "Transit İşlemler",   description: "Uluslararası transit işlemlerinizi yönetiyoruz.",            features: ["Transit takip","Güzergah planlama","Koordinasyon"],       color: "teal" },
    { icon: Shield,    title: "Gümrük Danışmanlığı",description: "Gümrük mevzuatı konusunda uzman danışmanlık.",               features: ["Mevzuat takibi","Risk analizi","Stratejik planlama"],      color: "red" },
  ]

  const colors = {
    blue:"bg-blue-100 text-blue-600", green:"bg-green-100 text-green-600",
    purple:"bg-purple-100 text-purple-600", orange:"bg-orange-100 text-orange-600",
    teal:"bg-teal-100 text-teal-600", red:"bg-red-100 text-red-600"
  }

  // GALERİ
  const IMAGES = [
  { src: '/images/gallery/1.jpeg', alt: 'Antrepo dış görünüm' },
  { src: '/images/gallery/2.jpeg', alt: 'Ofis kahvaltısı' },
  { src: '/images/gallery/3.jpeg', alt: 'Toplantı' },
  { src: '/images/gallery/4.jpeg', alt: 'Yetkilendirme töreni' },
  { src: '/images/gallery/5.jpeg', alt: 'Ziyaret toplantısı' },
  { src: '/images/gallery/6.jpeg', alt: 'Etkinlik' },
  { src: '/images/gallery/7.jpeg', alt: 'Ofis maskotu' },
  { src: '/images/gallery/8.jpeg', alt: 'Misafir karşılama' },
]

  const [open, setOpen] = useState(false)
  const [idx, setIdx] = useState(0)
  const openAt = useCallback((i)=>{ setIdx(i); setOpen(true)},[])
  const close = useCallback(()=>setOpen(false),[])
  const prev = useCallback(()=>setIdx(i => (i - 1 + IMAGES.length) % IMAGES.length),[])
  const next = useCallback(()=>setIdx(i => (i + 1) % IMAGES.length),[])

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Hizmetlerimiz</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Antrepo gümrük işlemlerinde ihtiyacınız olan tüm hizmetleri tek çatı altında sunuyoruz.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((s, i) => {
            const Icon = s.icon
            return (
              <Card key={i} className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <CardHeader>
                  <div className={`w-12 h-12 rounded-lg ${colors[s.color]} flex items-center justify-center mb-4`}>
                    <Icon size={24} />
                  </div>
                  <CardTitle className="text-xl text-gray-900">{s.title}</CardTitle>
                  <CardDescription className="text-gray-600">{s.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2 mb-2">
                    {s.features.map((f, k) => (
                      <li key={k} className="flex items-center text-sm text-gray-600">
                        <CheckCircle size={16} className="text-green-500 mr-2 flex-shrink-0" />
                        {f}
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            )
          })}
        </div>

        {/* GALERİ — Hizmetler ile duyurular arasına */}
        <div className="mb-16">
          <div className="mb-6 text-center">
            <h3 className="text-3xl font-bold text-gray-900">Galeri</h3>
            <p className="text-gray-600">Operasyon ve ofisimizden kareler</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {IMAGES.map((img, i) => (
              <button
                key={i}
                type="button"
                onClick={() => openAt(i)}
                className="group relative overflow-hidden rounded-xl border border-gray-200"
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-44 md:h-48 lg:h-52 object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors" />
              </button>
            ))}
          </div>

          {/* Lightbox */}
          {open && (
            <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" onClick={close}>
              <div className="relative max-w-5xl w-full" onClick={(e)=>e.stopPropagation()}>
                <img src={IMAGES[idx].src} alt={IMAGES[idx].alt} className="w-full h-auto rounded-lg shadow-2xl" />
                <button onClick={close} className="absolute -top-3 -right-3 bg-white text-gray-800 rounded-full px-3 py-1 text-sm shadow">×</button>
                <div className="absolute inset-y-0 left-0 flex items-center">
                  <button onClick={prev} className="m-2 bg-white/90 hover:bg-white text-gray-800 rounded px-3 py-2 shadow">‹</button>
                </div>
                <div className="absolute inset-y-0 right-0 flex items-center">
                  <button onClick={next} className="m-2 bg-white/90 hover:bg-white text-gray-800 rounded px-3 py-2 shadow">›</button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-4">Özel İhtiyaçlarınız İçin Danışmanlık</h3>
          <p className="text-blue-100 mb-0 max-w-2xl mx-auto">
            İşletmenize özel çözümler için bizimle iletişime geçin.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Services
